import { Link } from "react-router-dom";
// Inline SVG icons — professional, no extra deps
const IconAward = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const IconBook = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
  </svg>
);
const IconClock = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const IconBadge = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
  </svg>
);
const IconAcademic = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);
const IconUserPlus = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
  </svg>
);
const IconPlay = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
  </svg>
);
const IconDocument = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>
);
const IconCalendar = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
  </svg>
);
const IconSparkles = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
  </svg>
);
const IconKey = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.852-.719-1.157-1.954-.77-2.786l.298-.701A3.342 3.342 0 0118 3.75h-3.192" />
  </svg>
);
const IconBuilding = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21m6-18h2.25c.621 0 1.125.504 1.125 1.125v21c0 .621-.504 1.125-1.125 1.125h-4.382a1.125 1.125 0 01-1.125-1.125V3.75a1.125 1.125 0 011.125-1.125h2.25z" />
  </svg>
);
const IconHeart = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
  </svg>
);
const IconUser = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);
const IconChevronDown = () => (
  <svg className="w-5 h-5 flex-shrink-0 text-gold-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  </svg>
);
const IconArrowRight = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);

export function Landing() {
  return (
    <div className="min-h-screen flex flex-col font-sans antialiased">
      {/* Top bar — editorial accent */}
      <div className="bg-ink-950 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-center gap-4 flex-wrap">
          <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-slate-400">
            <IconAcademic />
            ACE-aligned continuing education
          </span>
          <span className="w-px h-4 bg-gold-400/50 hidden sm:block" aria-hidden />
          <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-slate-400">
            Health &amp; Wellness · ABA
          </span>
        </div>
        <div className="h-px w-full bg-gradient-to-r from-transparent via-gold-400/40 to-transparent" aria-hidden />
      </div>

      {/* Hero — split layout with image placeholder */}
      <section className="relative bg-ink-950 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-10%,rgba(166,133,30,0.1),transparent_50%)]" aria-hidden />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,rgba(15,20,25,0.4)_100%)]" aria-hidden />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 md:pt-24 md:pb-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-gold-400/40 bg-gold-400/5 px-4 py-2 mb-8">
                <IconAward />
                <span className="text-gold-300/95 text-xs font-semibold tracking-[0.2em] uppercase">
                  Professional development
                </span>
              </div>
              <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-[3.25rem] xl:text-[3.75rem] font-semibold tracking-tight leading-[1.08] text-white">
                Learn at your pace.
                <br />
                <span className="text-gold-300">Practice with purpose.</span>
              </h1>
              <p className="mt-8 text-lg md:text-xl text-slate-400 leading-[1.65] max-w-xl font-normal">
                High-quality video courses and interactive lessons in Health &amp; Wellness and Applied Behavior Analysis.
                Move through content in order, pass assessments, and earn your certificate.
              </p>
              <div className="mt-12 flex flex-wrap gap-4">
                <Link
                  to="/courses"
                  className="inline-flex items-center gap-2 rounded-md bg-gold-400 px-8 py-3.5 text-sm font-semibold text-ink-950 tracking-wide hover:bg-gold-300 transition-all duration-200 shadow-lg shadow-gold-400/20"
                >
                  Browse courses
                  <IconArrowRight />
                </Link>
                <Link
                  to="/signup"
                  className="inline-flex items-center gap-2 rounded-md border border-slate-500 px-8 py-3.5 text-sm font-semibold text-white tracking-wide hover:border-slate-400 hover:bg-white/5 transition-colors duration-200"
                >
                  Create account
                </Link>
              </div>
            </div>
            {/* Hero image */}
            <div className="relative aspect-[4/3] lg:aspect-[5/4] rounded-2xl overflow-hidden border border-ink-700/50 shadow-2xl">
              <img
                src="/images/image1.png"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Trust strip — with icons */}
      <section className="bg-ink-900 border-b border-ink-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6 text-slate-400 text-sm">
            <span className="flex items-center gap-3">
              <span className="text-gold-400/90"><IconBadge /></span>
              ACE-aligned content
            </span>
            <span className="flex items-center gap-3">
              <span className="text-gold-400/90"><IconClock /></span>
              Self-paced learning
            </span>
            <span className="flex items-center gap-3">
              <span className="text-gold-400/90"><IconAward /></span>
              Verifiable certificates
            </span>
            <span className="flex items-center gap-3">
              <span className="text-gold-400/90"><IconBook /></span>
              Evidence-based training
            </span>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-28 md:py-36 bg-stone">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
              Simple process
            </p>
            <div className="mt-4 w-12 h-px bg-gold-400/50 mx-auto" aria-hidden />
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-ink-950 mt-6 tracking-tight">
              How it works
            </h2>
            <p className="mt-5 text-gray-600 max-w-xl mx-auto text-base leading-relaxed">
              Three clear steps from enrollment to certification.
            </p>
          </div>
          <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12">
            {[
              { step: "01", icon: <IconUserPlus />, title: "Enroll", body: "Pay for a plan once (or use an access code) to unlock all courses. Then connect to any course and start learning." },
              { step: "02", icon: <IconPlay />, title: "Learn", body: "Watch videos and complete interactive activities in order. Progress is saved so you can resume anytime." },
              { step: "03", icon: <IconAward />, title: "Certify", body: "Pass the final assessment (80%+) and download your certificate. Ready for your records or employer." },
            ].map((item) => (
              <div key={item.step} className="relative group">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold-400/10 text-gold-500 border border-gold-400/20 group-hover:border-gold-400/40 transition-colors">
                    {item.icon}
                  </span>
                  <span className="font-serif text-2xl font-semibold text-gold-500/90 tabular-nums">
                    {item.step}
                  </span>
                  <div className="flex-1 h-px bg-ink-700/20" aria-hidden />
                </div>
                <h3 className="mt-6 font-serif text-2xl font-semibold text-ink-950 tracking-tight">
                  {item.title}
                </h3>
                <p className="mt-4 text-gray-600 leading-relaxed text-[15px]">
                  {item.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-28 md:py-36 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
              Why choose us
            </p>
            <div className="mt-4 w-12 h-px bg-gold-400/50 mx-auto" aria-hidden />
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-ink-950 mt-6 tracking-tight">
              Built for professionals
            </h2>
            <p className="mt-5 text-gray-600 max-w-xl mx-auto text-base leading-relaxed">
              Practical, evidence-based training for real-world application.
            </p>
          </div>
          <div className="mt-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200/80 rounded-2xl overflow-hidden shadow-soft">
            {[
              { icon: <IconCalendar />, title: "Self-paced", desc: "Complete lessons on your schedule. No deadlines except your own." },
              { icon: <IconSparkles />, title: "Interactive", desc: "Quizzes, scenarios, and activities reinforce what you learn." },
              { icon: <IconAward />, title: "Certified", desc: "Earn a certificate you can download and share after passing the assessment." },
              { icon: <IconBadge />, title: "Focused", desc: "Health & Wellness and ABA content designed for real-world use." },
              { icon: <IconDocument />, title: "Structured", desc: "Clear learning path with lessons in order and a final assessment." },
              { icon: <IconKey />, title: "Accessible", desc: "Use access codes from your organization or purchase directly." },
            ].map((item) => (
              <div
                key={item.title}
                className="group bg-white p-8 md:p-10 hover:bg-stone/50 transition-all duration-300 border-l-2 border-transparent hover:border-gold-400/50 flex gap-4"
              >
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gold-400/10 text-gold-500">
                  {item.icon}
                </span>
                <div>
                  <h3 className="font-serif text-xl font-semibold text-ink-950 tracking-tight">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-gray-600 leading-relaxed text-[15px]">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who it's for — with image placeholder */}
      <section className="py-28 md:py-36 bg-ink-950 text-white relative">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/30 to-transparent" aria-hidden />
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-ink-700">
                <img
                  src="/images/image2.png"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="lg:col-span-7 order-1 lg:order-2">
              <p className="text-gold-300/90 font-semibold text-xs tracking-[0.2em] uppercase">
                Audience
              </p>
              <div className="mt-4 w-12 h-px bg-gold-400/50" aria-hidden />
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold mt-6 tracking-tight">
                Who it's for
              </h2>
              <p className="mt-5 text-slate-400 max-w-xl text-base leading-relaxed">
                Designed for practitioners, parents, and organizations who value quality continuing education.
              </p>
              <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  { icon: <IconUser />, title: "Practitioners", body: "BCBAs, RBTs, and professionals seeking ACE CEUs and structured professional development." },
                  { icon: <IconHeart />, title: "Parents & caregivers", body: "Families who want evidence-based strategies and clear, practical training they can trust." },
                  { icon: <IconBuilding />, title: "Organizations", body: "Teams and agencies using access codes to deliver consistent training and track completion." },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="border border-ink-800 bg-ink-900/40 p-6 rounded-xl hover:border-ink-700 transition-colors duration-300"
                  >
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gold-400/10 text-gold-400 mb-4">
                      {item.icon}
                    </span>
                    <h3 className="font-serif text-lg font-semibold text-gold-300 tracking-tight">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-slate-400 leading-relaxed text-[15px]">
                      {item.body}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What you get — with certificate image placeholder */}
      <section className="py-28 md:py-36 bg-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
              Outcomes
            </p>
            <div className="mt-4 w-12 h-px bg-gold-400/50 mx-auto" aria-hidden />
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-ink-950 mt-6 tracking-tight">
              What you get
            </h2>
          </div>
          <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="flex gap-6">
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-gold-400/40 bg-gold-50 text-gold-500">
                  <IconAward />
                </span>
                <div>
                  <h3 className="font-serif text-xl font-semibold text-ink-950 tracking-tight">
                    Verifiable certificate
                  </h3>
                  <p className="mt-3 text-gray-600 leading-relaxed text-[15px]">
                    Download your certificate after passing the final assessment. Ready for licensing or employer records.
                  </p>
                </div>
              </div>
              <div className="flex gap-6">
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-gold-400/40 bg-gold-50 text-gold-500">
                  <IconDocument />
                </span>
                <div>
                  <h3 className="font-serif text-xl font-semibold text-ink-950 tracking-tight">
                    Structured content
                  </h3>
                  <p className="mt-3 text-gray-600 leading-relaxed text-[15px]">
                    Video lessons and activities in a clear sequence. Progress is saved so you can learn at your pace.
                  </p>
                </div>
              </div>
            </div>
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-gray-200 bg-white shadow-soft-lg">
              <img
                src="/images/image3.png"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Quote */}
      <section className="py-28 md:py-36 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-10 items-start">
            <div className="flex-shrink-0 w-24 h-24 rounded-2xl overflow-hidden border border-gray-200 ring-1 ring-gray-100">
              <img
                src="/images/image4.png"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 border-l-2 border-gold-400/70 pl-8 md:pl-10">
              <blockquote className="font-serif text-2xl md:text-3xl font-medium text-ink-950 leading-snug tracking-tight">
                Professional development that fits your schedule and meets high standards.
              </blockquote>
              <p className="mt-8 text-sm text-gray-500 font-medium tracking-wide">
                Built for practitioners and organizations who value quality
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-28 md:py-36 bg-stone">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
              Support
            </p>
            <div className="mt-4 w-12 h-px bg-gold-400/50 mx-auto" aria-hidden />
            <h2 className="font-serif text-3xl md:text-4xl font-semibold text-ink-950 mt-6 tracking-tight">
              Frequently asked questions
            </h2>
          </div>
          <dl className="mt-20 space-y-0 divide-y divide-gray-200/80">
            {[
              { q: "How do I get access to a course?", a: "Pay once for a plan (on the home page or after signup) or use an access code from your organization. After that, you can access any course from your dashboard." },
              { q: "Is the certificate recognized?", a: "Our certificates are designed to align with ACE continuing education standards. Check with your licensing body for specific requirements." },
              { q: "Can I learn at my own pace?", a: "Yes. There are no deadlines. Complete lessons and the final assessment when you're ready. Your progress is saved automatically." },
              { q: "What if I don't pass the assessment?", a: "You can retake the final assessment. You need 80% or higher to pass and receive your certificate." },
            ].map((faq) => (
              <div key={faq.q} className="py-10 first:pt-0 flex gap-4">
                <span className="flex-shrink-0 mt-0.5 text-gold-500">
                  <IconChevronDown />
                </span>
                <div>
                  <dt className="font-serif text-lg font-semibold text-ink-950 tracking-tight">
                    {faq.q}
                  </dt>
                  <dd className="mt-3 text-gray-600 leading-relaxed text-[15px]">
                    {faq.a}
                  </dd>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-28 md:py-36 bg-ink-950 text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/40 to-transparent" aria-hidden />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_100%,rgba(166,133,30,0.08),transparent)]" aria-hidden />
        <div className="relative max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight">
            Ready to start?
          </h2>
          <p className="mt-6 text-base text-slate-400 leading-relaxed">
            Create a free account, pick a payment plan, and get access to all courses. Pay once—then learn anytime.
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <Link
              to="/signup"
              className="inline-flex items-center gap-2 rounded-md bg-gold-400 px-8 py-3.5 text-sm font-semibold text-ink-950 tracking-wide hover:bg-gold-300 transition-colors duration-200 shadow-lg shadow-gold-400/20"
            >
              Sign up free
              <IconArrowRight />
            </Link>
            <Link
              to="/courses"
              className="inline-flex rounded-md border border-slate-500 px-8 py-3.5 text-sm font-semibold text-white tracking-wide hover:border-slate-400 hover:bg-white/5 transition-colors duration-200"
            >
              View courses
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
